export const APP_NAME = "AIXA Share";

export const DEFAULT_PAGE_SIZE = 50;

export const SHARE_LINK_MAX_DAYS = parseInt(
  import.meta.env.VITE_SHARE_LINK_MAX_DAYS || "30",
  10
);

// Document retention settings (security - documents are copies, not originals)
export const DOCUMENT_AUTO_DELETE_DAYS = 30; // Documents auto-delete after 30 days
export const SHARE_DURATION_MIN_DAYS = 1; // Minimum share duration
export const SHARE_DURATION_DEFAULT_DAYS = 7; // Default share duration

export const SHARE_DURATION_PRESETS = [
  { label: "1 day", value: 1 },
  { label: "3 days", value: 3 },
  { label: "7 days (Recommended)", value: 7 },
  { label: "14 days", value: 14 },
  { label: "30 days (Maximum)", value: 30 },
] as const;

export const SESSION_TIMEOUT_MS = 15 * 60 * 1000; // 15 minutes
export const SESSION_WARNING_MS = 12 * 60 * 1000; // 12 minutes

export const DEBOUNCE_SEARCH_MS = 300;

export const UPLOAD_PROGRESS_AUTO_DISMISS_MS = 3000;

export const PREVIEW_SUPPORTED_TYPES = {
  pdf: ["application/pdf"],
  image: ["image/png", "image/jpeg", "image/gif", "image/webp", "image/svg+xml"],
  office: [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/msword",
    "application/vnd.ms-excel",
    "application/vnd.ms-powerpoint",
  ],
  text: ["text/plain", "text/markdown", "text/csv"],
};

export const FOLDER_COLORS = [
  "#10B981", // Emerald (default)
  "#3B82F6", // Blue
  "#8B5CF6", // Violet
  "#EC4899", // Pink
  "#EF4444", // Red
  "#F97316", // Orange
  "#EAB308", // Yellow
  "#22C55E", // Green
  "#06B6D4", // Cyan
  "#6366F1", // Indigo
  "#64748B", // Slate
];

export const FOLDER_ICONS = [
  { key: "folder", label: "Folder" },
  { key: "folder-open", label: "Archive" },
  { key: "file", label: "Documents" },
  { key: "picture", label: "Images" },
  { key: "video", label: "Videos" },
  { key: "sound", label: "Audio" },
  { key: "code", label: "Code" },
  { key: "database", label: "Data" },
  { key: "lock", label: "Private" },
  { key: "star", label: "Important" },
  { key: "heart", label: "Favorites" },
  { key: "team", label: "Shared" },
] as const;

export const SORT_OPTIONS = [
  { label: "Name", value: "name" },
  { label: "Date modified", value: "date" },
  { label: "Size", value: "size" },
  { label: "Type", value: "type" },
] as const;

export const ACTIVITY_ACTIONS = {
  upload: "uploaded",
  download: "downloaded",
  view: "viewed",
  delete: "deleted",
  share: "shared",
  unshare: "removed sharing for",
  restore: "restored",
  move: "moved",
  rename: "renamed",
} as const;

export const ROUTES = {
  home: "/",
  files: "/share",
  folder: (folderId: string) => `/share/${folderId}`,
  shared: (token: string) => `/shared/${token}`,
  shredder: "/share/shredder",
} as const;

export const API_ROUTES = {
  // Files
  files: "/files",
  filesDeleted: "/files-deleted",
  file: (id: string) => `/files/${id}`,
  fileUpload: "/files/upload",
  fileDownload: (id: string) => `/files/${id}/download`,

  // Folders
  folders: "/folders",
  folder: (id: string) => `/folders/${id}`,

  // Shares (authenticated)
  shares: "/shares",
  share: (id: string) => `/shares/${id}`,

  // Public share access (no auth required)
  publicShare: (token: string) => `/public/shares/${token}`,
  publicShareDownload: (token: string) => `/public/shares/${token}/download`,

  // Activity
  activity: "/activity",
} as const;
